import { SearchResults } from '../../types';

export const SEARCH_MIN_CHARS = 2;

export const EMPTY_RESULTS: SearchResults = {
	assets: { items: [], total: 0 },
	collections: { items: [], total: 0 },
	pages: { items: [], total: 0 },
	guidelines: { items: [], total: 0 },
	metaproperties: [],
	tags: [],
};
